import en from './suspiciousTransactionString.en';

export default {
  en,
};
